import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const GET_GALLERY_DATA = `${API_URL}/api/v1/parent/gallery`;
export const DELETE_GALLERY = `${API_URL}/api/v1/parent/delete-activity`;
export const WEB_FILTER_URL = `${API_URL}/api/v1/parent/web-filter`;

export function getGalleryData(payload) {
  return axiosInstance({
    url: GET_GALLERY_DATA,
    method: "GET",
    params: payload
  });
}

export function deleteGallery(payload) {
  return axiosInstance({
    url: DELETE_GALLERY,
    method: "POST",
    data: payload,
  });
}

export function getWebFilter(payload) {
  return axiosInstance({
    url: WEB_FILTER_URL,
    method: "GET",
    params: payload
  });
}
